import React, { useState, useEffect, useContext } from 'react';

// eslint-disable-next-line import/no-cycle
import { MyContext } from '../../component/SidebarAdmin';

// Assets imports
import SearchIcon from '../../assets/imgs/search_icon.svg';

// Components imports
import DemandList from '../../component/ListComponents/DemandList';
import EditDemand from '../../component/EditComponents/EditDemand';
import Loading from '../../component/Loading';
import NoResultsComponent from '../../component/NoResultsComponent';
import EditTemplates from '../../component/EditComponents/EditTemplates';
import ReportDemand from '../../component/PDFGenerator/ReportDemand';

// Firebase import
import firebase from '../../config/Firebase';


export default function DemandAdmin() {
  const [filter, setFilter] = useState('titulo');
  const [editPopup, setEditPopup] = useState(false);
  const [templatePopup, setTemplatePopup] = useState(false);
  const [selectedItem, setSelectedItem] = useState(undefined);
  const [search, setSearch] = useState('');
  const [places, setPlaces] = useState();
  const [template, setTemplate] = useState();
  const [action, setAction] = useState('Editar');
  const [filteredPlaces, setFilteredPlaces] = useState();
  const { city, role } = useContext(MyContext);
  const [reportPopup, setReportPopup] = useState(false);
  const [answers, setAnswers] = useState(false);
  const [data, setDataReport] = useState(false);

  const buildQuery = () => {
    const currFilter = filter === 'searchBar' ? 'titulo' : filter;

    const docs = firebase.firestore()
      .collection('EstudoDemanda')
      .where('cidade', '==', city)
      .orderBy(currFilter);
    
    return docs;
  };

  const getFirstPage = async () => {
    const newDocs = await buildQuery().get();

    setPlaces(newDocs);
    setFilteredPlaces(newDocs);
  };

  useEffect(() => {
    if (city)
      getFirstPage();
  }, [city, filter]);

  useEffect(() => {
    if (!editPopup) {
      setSelectedItem(undefined);
      if (city)
        getFirstPage();
    }
  }, [editPopup]);

  const handleEdit = (doc) => {
    setSelectedItem(doc);
    setAction('Editar');
    setEditPopup(true);
  };

  const handleChange = () => {
    getFirstPage();
  };

  const searchInventoryText = (doc) => {
    if (search === '')
      return true;
    
    const isInTitle = doc.data().name.toLowerCase().includes(search.toLowerCase());
    const isInEmail = doc.data().email.toLowerCase().includes(search.toLowerCase());
    return isInTitle || isInEmail;
  };

  const handleSearch = () => {
    if (places.docs) {
      let filteredPlaces = places.docs.filter((doc) => searchInventoryText(doc));
      filteredPlaces = { docs: filteredPlaces };
      setFilteredPlaces(filteredPlaces);
    }
  };

  const handleOpenReportDemand = (answers, data) => {
    setAnswers(answers);
    setDataReport(data);
    setReportPopup(true);
  };

  if (!places || !city) {
    return <Loading />;
  }

  if (reportPopup) {
    return <ReportDemand answers={answers} data={data} setReportPopup={setReportPopup} />;
  }

  if (templatePopup) {
    return (
      <div className='InventarioAdmin'>
        <EditTemplates object={'Estudo de Demanda'} refDoc={'EstudoDemanda'} setEditPopup={setEditPopup} setTemplatePopup={setTemplatePopup} setAction={setAction} setSelectedItem={setSelectedItem} setTemplate={setTemplate} city={city} />
      </div>
    );
  }

  if (editPopup) {
    return (
      <div className='InventarioAdmin'>
        <EditDemand setEditPopup={setEditPopup} doc={selectedItem} action={action} userCity={city} template={template} role={role} />
      </div>
    );
  }

  return (
    <div className='InventarioAdmin'>
      <div className='body_inventory_adm'>
        <div className='div_title_inventory_adm'>
          <h1>Estudos de Demanda</h1>
        </div>
        <div className='div_create_inventory_adm'>
          <p className='create_inventory_adm' onClick={() => setTemplatePopup(true) }>Criar Novo Estudo de Demanda</p>
        </div>
        <div className='div_browse_inventory_adm'>
          <input type='text' className='input_browse_inventory' onChange={(e) => { setSearch(e.target.value); handleSearch(); }} placeholder='Buscar' />
          <button type="button" className='btn_browse_inventory_adm' disabled>
            <img src={SearchIcon} alt='Icone de pesquisa' className='search_icon_admin'/>
          </button>
        </div>
        { filteredPlaces && filteredPlaces.docs && filteredPlaces.docs.length > 0 ? (
        <div className='div_table_inventory_adm' id='div_table_inventory_adm'>
          <table className='table_inventory_adm'>
            <thead>
                <tr className="row_table_inventory th_table_admin">
                <td className='column_title_table_inventory th_table_admin' onClick={() => setFilter('titulo')}>Titulo</td>
                <td className='column_title_table_inventory th_table_admin' onClick={() => setFilter('cidade')}>Cidade</td>
                <td className='column_title_table_inventory th_table_admin' onClick={() => setFilter('dataIni')}>Data de Início</td>
                <td className='column_title_table_inventory th_table_admin' onClick={() => setFilter('dataFim')}>Data de Fim</td>
                <td className='column_title_table_inventory th_table_admin'>Numero de Respondentes</td>
                <td className='column_title_table_inventory th_table_admin' onClick={() => setFilter('publicado')}>Publicado</td>
                <td className='column_table_inventory th_table_admin'></td>
                </tr>
            </thead>
            <tbody>
              {
                filteredPlaces.docs.map((doc) => {
                  return <DemandList doc={doc} key={doc.id} handleEdit={handleEdit} handleChange={handleChange} handleOpenReportDemand={handleOpenReportDemand} role={role} />;
                })
              }
            </tbody>
          </table>
        </div>) : <NoResultsComponent title={'Usuários'} search={search} /> }
      </div>
    </div>
  );
}